<div *ngIf="politisLogos" class="politis-logo">
  <span class="tomtom"></span>
  <span class="politis"></span>
</div>
<p>
  &copy; CARTO<span>·</span
  ><span class="attribGeoText"
    >Powered by
    <img class="cartoLogo" src="/assets/img/logos/carto-logo-negative.svg" />
    Engineered by <span>Geographica</span></span
  >
</p>
